import { render, staticRenderFns } from "./ProductionFileGenerator.vue?vue&type=template&id=4598d54d&scoped=true"
import script from "./ProductionFileGenerator.vue?vue&type=script&lang=ts"
export * from "./ProductionFileGenerator.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ProductionFileGenerator.vue?vue&type=style&index=0&id=4598d54d&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4598d54d",
  null
  ,true
)

export default component.exports